import { Location } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'

import { AngularService } from './angular.service'
import { AuthenticationService } from './authentication.service'
import { DataService } from './data'
import { LoadingService } from './loading.service'
import { ModalService } from './modals'
import { NotificationService } from './notification.service'
import { NgProgressService } from './progress'
import { MeetingHubService } from './services/meeting-hub.service'
import { MeetingContentSyncService } from './services/meeting-content-sync.service'
import { MeetingTimerService } from './services/meeting-timer.service'
import { UtilityService } from './utility'

@Injectable()
export class Services {
    constructor(
        public utility: UtilityService,
        private httpClient: HttpClient,
        private modal: NgbModal,
        private pService: NgProgressService,
        private toasterService: ToastrService,
        private authService: AuthenticationService,
        private location: Location,
        private router: Router,
        public meetingTimer: MeetingTimerService,
        public meetingHub: MeetingHubService,
        public meetingContentSync: MeetingContentSyncService,
    ) {
        this.data = new DataService(this, httpClient)
        this.modals = new ModalService(modal)
        this.notification = new NotificationService(toasterService, router)
        this.loading = new LoadingService(pService)
        this.authentication = authService
        this.angular = new AngularService(router, location)
    }

    public data: DataService
    public modals: ModalService
    public notification: NotificationService
    public loading: LoadingService
    public authentication: AuthenticationService
    public angular: AngularService
}
